import { ORDER_TYPES } from '@exodus/fiat-client'
import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file

const resultFunction = (cryptoAssets, fiatAssets) =>
  memoize((orderType) => {
    const supportedProperty = orderType === ORDER_TYPES.buy ? 'isBuySupported' : 'isSellSupported'
    const providers = new Set()

    for (const asset of Object.values(cryptoAssets)) {
      for (const [providerName, provider] of Object.entries(asset.providers)) {
        if (provider[supportedProperty]) {
          providers.add(providerName)
        }
      }
    }

    for (const asset of Object.values(fiatAssets)) {
      for (const [providerName, provider] of Object.entries(asset.providers)) {
        if (provider[supportedProperty] && providers.has(providerName)) {
          return true
        }
      }
    }

    return false
  })

const getIsAssetIntersectionByOrderTypeSelectorDefinition = {
  id: 'getIsAssetIntersectionByOrderType',
  resultFunction,
  dependencies: [{ selector: 'cryptoAssets' }, { selector: 'fiatAssets' }],
}

export default getIsAssetIntersectionByOrderTypeSelectorDefinition
